<template>
  <HXContentCard title="Editar Centro de Costo" :toBack="{ name: 'CentroCostos' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label for=" " class="form-label">Nombre Centro de Costo</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre del Centro de Costo..."
              type="text" class="form-control" id=" " />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Centro de Operación</label>
            <b-form-select required v-model="item.centroOperacionId" :options="ListCentroOperacion"
              text-field="descripcion" value-field="id">
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Actualizar Centro de Costo
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>
<script>
export default {
  data() {
    return {
      item: {
        descripcion: "",
        centroOperacionId: "",
        empresaId: "",
        estado: 1,
      },
      isCreating: false,
      ListCentroOperacion: [],
      selected: null,
      empresaSelected: null,
      usuario: { rol: { nivel: 0 } },
      id: "",
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.id = this.$route.params.id;
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      console.log("usuario ", this.usuario);
      //this.item.EmpresaId = this.usuario.empresa.id;
      await this.getData();
      await this.getCentroOperacionByEmpresa();
      this.$isLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  },
  methods: {
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "CentroCosto/Get/" + this.id,
        });
        this.item = res.data;

        console.log("list data Centros de Costo* ************* ", this.item);
      } catch (error) {
        this.item = {};
        console.log("err", error);
      }
    },
    async getCentroOperacionByEmpresa() {
      try {

        // usamos el empresaId que ya viene en el CentroCosto
        let res = await this.$store.dispatch("hl_get", {
          path: "CentroOperacion/GetByEmpresa/" + this.item.empresaId,
        });

        this.ListCentroOperacion = res.data;

        console.log("Centros Operacion:", this.ListCentroOperacion);

      } catch (error) {
        this.ListCentroOperacion = [];
        console.log(error);
      }
    },
    async saveData() {
      this.isCreating = true;

      try {

        const payload = {
          id: this.item.id,
          descripcion: this.item.descripcion,
          centroOperacionId: this.item.centroOperacionId,
          estado: this.item.estado,
          empresaId: this.item.empresaId
        };

        const res = await this.$store.dispatch("hl_put", {
          path: "CentroCosto/Update",
          data: payload,
        });

        console.log("Respuesta:", res);

        if (res?.success) {

          this.$vs.notification({
            color: "success",
            title: "Éxito",
            text: "Centro de costo actualizado correctamente",
            position: "top-right",
          });

          this.$router.push({ name: "CentroCostos" });

        }

      } catch (error) {

        console.log("Error:", error.response?.data);

        this.$vs.notification({
          color: "danger",
          title: "Error",
          text: "No se pudo actualizar el Centro de Costo",
          position: "top-right",
        });

      } finally {
        this.isCreating = false;
      }
    }

  },
};
</script>
